import angular from "angular";
import { MeridianIdMovementConfirmedModalComponent } from "./meridian-id-movement-confirmed.component";
import { MeridianIdMovementService } from "./meridian-id-movement.service";
import { MoveMeridianIdModalComponent } from "./move-meridian-id-modal.component";

export const MoveMeridianIdModule = angular
    .module("apex.mainApp.icdCorporation.moveMeridianID", [])
    .component("apexMoveMeridianIdModal", MoveMeridianIdModalComponent)
    .component("apexMeridianIdMovementConfirmedModal", MeridianIdMovementConfirmedModalComponent)
    .service("meridianIdMovementService", MeridianIdMovementService)
    .name;
